import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { APIResultScheduleCompanyResponse, ParticipantControllerService, ScheduleCompanyResponse, ScheduleCompanySlotPeriodResponse } from '@ent-regis/entregis-ts-angular';
import { b64toBlob, saveFileBlob } from 'src/app/functions/file.function';
import { AuthService } from 'src/app/shared/services/auth.service';

@Component({
  selector: 'app-company-meeting-schedule-section',
  templateUrl: './company-meeting-schedule-section.component.html',
  styleUrls: ['./company-meeting-schedule-section.component.scss']
})
export class CompanyMeetingScheduleSectionComponent {

  @Input() isSentScheduleEmail: boolean = false;
  @Input() contactEmail: string = '';

  public now = new Date();
  scheduleCompanyResponse: ScheduleCompanyResponse = null;
  eventTypeEnum = ScheduleCompanyResponse.EventTypeEnum;
  private personName: string = '';

  expandedAttendees = new Set<string>();

  constructor(
    private participantControllerService: ParticipantControllerService,
    private authService: AuthService,
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['isSentScheduleEmail'] && changes['isSentScheduleEmail'].currentValue) {
      this.getScheduleCompanyInfo();
      this.personName = this.authService.getName();
    }
  }
  
  getScheduleCompanyInfo() {
    this.participantControllerService.getMeetingScheduleUsingGET()
      .subscribe((res: APIResultScheduleCompanyResponse) => {
        const data = res && res.data ? res.data : null;
        if (!data || !data.slots) {
          this.scheduleCompanyResponse = data;
          return;
        }

        const filteredSlots = data.slots.filter(slot =>
          slot && slot.slotPeriods && slot.slotPeriods.length > 0);

        this.scheduleCompanyResponse = {
          ...data,
          slots: filteredSlots
        };
      });
  }

  getSortedAttendees(slotPeriod: ScheduleCompanySlotPeriodResponse): any[] {
    const attendees = slotPeriod && slotPeriod.attendees ? [...slotPeriod.attendees] : [];
    return attendees.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
  }

  isAttendeesExpanded(key: string): boolean {
    return this.expandedAttendees.has(key);
  }

  toggleAttendees(key: string): void {
    if (this.expandedAttendees.has(key)) {
      this.expandedAttendees.delete(key);
    } else {
      this.expandedAttendees.add(key);
    }
  }

  getMeetingType(slotPeriod: ScheduleCompanySlotPeriodResponse): string {
    if (!slotPeriod || !slotPeriod.meetingType) {
      return '';
    }
    switch(slotPeriod.meetingType) {
      case ScheduleCompanySlotPeriodResponse.MeetingTypeEnum.GROUP: return 'Group';
      case ScheduleCompanySlotPeriodResponse.MeetingTypeEnum.ONEONONE: return '1 on 1';
      case ScheduleCompanySlotPeriodResponse.MeetingTypeEnum.VIRTUALGROUP: return 'Virtual (Group)';
      default: return slotPeriod.meetingType;
    }
  }

  getMeetingTypeClass(meetingType: ScheduleCompanySlotPeriodResponse.MeetingTypeEnum): string {
    if (meetingType == ScheduleCompanySlotPeriodResponse.MeetingTypeEnum.VIRTUALGROUP) return 'badge--meeting-type';
    return '';
  }

  isLoginPerson(speakerName: string): boolean {
    if (!speakerName) {
      return false;
    }

    const normalizedName = speakerName.trim().toLowerCase();
    if (!normalizedName) {
      return false;
    }

    const normalizedPersonName = this.personName.trim().toLowerCase();
    return normalizedName === normalizedPersonName;
  }

  get hasScheduleSlots(): boolean {
    return !!(this.scheduleCompanyResponse
      && this.scheduleCompanyResponse.slots
      && this.scheduleCompanyResponse.slots.length);
  }

  get timezone(): string {
    return this.scheduleCompanyResponse
      && this.scheduleCompanyResponse.eventType === this.eventTypeEnum.THAILANDFOCUS
      ? 'UTC +7'
      : null;
  }

  get isThailandFocus(): boolean {
    return this.scheduleCompanyResponse
      && this.scheduleCompanyResponse.eventType === this.eventTypeEnum.THAILANDFOCUS;
  }

  trackByIndex(index: number): number {
    return index;
  }

  downloadPdf() {
    const offset = (new Date().getTimezoneOffset() / -60);
    this.participantControllerService.downloadPdfMeetingScheduleUsingGET(offset).subscribe((result) => {
      const blob = b64toBlob(result.data.data, result.data.fileType);
      saveFileBlob(blob, result.data.fileName);
    });
  }

}
